import { Component, OnInit } from '@angular/core';
import { Paso3 } from 'src/app/global/interfaces/paso-3';
import { LocalStorageService } from 'src/app/global/services/localstorage.service';
import { environment } from 'src/environments/environment.prod';

@Component({
  selector: 'app-pasos-seguir',
  templateUrl: './pasos-seguir.component.html',
  styleUrls: ['./pasos-seguir.component.scss']
})
export class PasosSeguirComponent implements OnInit {

  loading: boolean;
  pasosSeguir: string;
  linkWix: string = environment.linkAgendaWix;
  stepsToFollow: any;

  constructor(private localStorageService: LocalStorageService) {
  }

  ngOnInit() {
    const dataPaso3: Paso3 = this.localStorageService.getPaso3();
    this.pasosSeguir = dataPaso3.siguientePaso === null ? 'NO_STEPS' : dataPaso3.siguientePaso.data;
    this.fillStepsInformation();
  }

  fillStepsInformation() {
    switch (this.pasosSeguir) {
      case "ARRIENDO_SMARTPOS":
      case "ARRIENDO_LITE_POS":
        this.stepsToFollow = {
          products: [
            {
              steps: [
                {
                  title: "Espera nuestro correo de confirmación.",
                  subtitle: "En los próximos minutos recibirás un correo electrónico confirmando el arriendo de tu nuevo equipo. En caso de no recibir nuestro email, revisa tu carpeta SPAM."
                },
                {
                  title: "Instalación de tu equipo POS.",
                  subtitle: "El día de la instalación el técnico te capacitará en el uso de tu nuevo equipo y el uso de la aplicación de gestión gastronómica."
                },
                {
                  title: "¡Haz crecer tu negocio!",
                  subtitle: "Agiliza tus ventas gestionando tu local e imprimiendo voucher, comandas y boletas desde un solo dispositivo."
                }
              ]
            }
          ]
        }
        break;
      case "ARRIENDO_MPOS":
      case "ARRIENDO_POS_MOVIL_PLAZO_INDEFINIDO_POR_COURIER":
      case "ARRIENDO_POS_FIJO_POR_COURIER":
        this.stepsToFollow = {
          products: [
            {
              steps: [
                {
                  title: "Espera nuestro correo de confirmación.",
                  subtitle: "En los próximos minutos recibirás un correo electrónico confirmando el arriendo de tu nuevo equipo. En caso de no recibir nuestro email, revisa tu carpeta SPAM."
                },
                {
                  title: "Coordinaremos el despacho.",
                  subtitle: "Dentro de las 48 horas anteriores a la instalación del equipo te contactaremos para confirmar la fecha y datos de entrega."
                },
                {
                  title: "¡Activa tu equipo y comienza a vender!",
                  subtitle: "Recibirás tu equipo con las instrucciones para que lo actives de manera simple y rápida. ¡Una vez listo podrás vender al instante!"
                }
              ]
            }
          ]
        }
        break;
      case "ARRIENDO_POS_MOVIL_PLAZO_INDEFINIDO_POR_TECNICO":
      case "ARRIENDO_POS_FIJO_POR_TECNICO":
        this.stepsToFollow = {
          products: [
            {
              steps: [
                {
                  title: "Espera nuestro correo de confirmación.",
                  subtitle: "En los próximos minutos recibirás un correo electrónico confirmando el arriendo de tu nuevo equipo. En caso de no recibir nuestro email, revisa tu carpeta SPAM."
                },
                {
                  title: "Coordinaremos la instalación.",
                  subtitle: "Dentro de las 48 horas anteriores a la instalación del equipo te contactaremos para confirmar la fecha y datos de entrega."
                },
                {
                  title: "Te contactaremos para la instalación.",
                  subtitle: "Un técnico realizará la instalación en tu local y te explicará el funcionamiento básico de tu nuevo equipo. ¡Una vez activado podrás vender al instante!."
                }
              ]
            }
          ]
        }
        break;
      case "VENTA_MPOS":
        this.stepsToFollow = {
          products: [
            {
              steps: [
                {
                  title: "Maquinita MPOS: recibirás un SMS de despacho.",
                  subtitle: "El día de la entrega recibirás un mensaje de texto de la empresa de entrega que se asignó para el despacho de tu Maquinita MPOS, indicando que tu producto se encuentra en camino."
                },
                {
                  title: "Vincula tu Maquinita MPOS.",
                  subtitle: "Recibirás tu Maquinita MPOS con las instrucciones para que lo actives de manera simple y rápida, no te tomará más de 5 minutos. <br>¡Una vez listo podrás vender al instante!."
                }
              ]
            }
          ]
        }
        break;
      case "LINK_PAGO":
        this.stepsToFollow = {
          products: [
            {
              steps: [
                {
                  title: "Correo de confirmación contratación.",
                  subtitle: "En los próximos minutos recibirás un correo electrónico confirmando la contratación de tu Pack, posterior a esto ya estará activo tu comercio en Webpay.cl."
                },
                {
                  title: "Edita tu perfil.",
                  subtitle: "Comparte vía redes sociales, correo o Whatsapp tu link de venta, para que tus clientes puedan pagar online con tarjeta de débito o crédito."
                },
                {
                  title: "Comparte tu link de pago.",
                  subtitle: "Comparte vía redes sociales, correo o Whatsapp tu link de pago, para que tus clientes puedan pagar online con tarjeta de débito o crédito."
                }
              ]
            }
          ]
        }
        break;
      case "PACK_VENTA_MPOS_LP":
        this.stepsToFollow = {
          products: [
            {
              productTitle: "Link de pago Webpay.cl",
              steps: [
                {
                  title: "Correo de confirmación contratación.",
                  subtitle: "En los próximos minutos recibirás un correo electrónico confirmando la contratación de tu Pack, posterior a esto ya estará activo tu comercio en Webpay.cl."
                },
                {
                  title: "Edita tu perfil.",
                  subtitle: "Comparte vía redes sociales, correo o Whatsapp tu link de venta, para que tus clientes puedan pagar online con tarjeta de débito o crédito."
                },
                {
                  title: "Comparte tu link de pago.",
                  subtitle: "Comparte vía redes sociales, correo o Whatsapp tu link de pago, para que tus clientes puedan pagar online con tarjeta de débito o crédito."
                }
              ]
            },
            {
              productTitle: "Maquinita MPOS",
              steps: [
                {
                  title: "Maquinita MPOS: recibirás un SMS de despacho.",
                  subtitle: "El día de la entrega recibirás un mensaje de texto de la empresa de entrega que se asignó para el despacho de tu Maquinita MPOS, indicando que tu producto se encuentra en camino."
                },
                {
                  title: "Vincula tu Maquinita MPOS.",
                  subtitle: " Recibirás tu Maquinita MPOS con las instrucciones para que lo actives de manera simple y rápida, no te tomará más de 5 minutos. <br>¡Una vez listo podrás vender al instante!."
                }
              ]
            }
          ]
        }
        break;
      case "PACK_POS_MOVIL_LP_PLAZO_INDEFINIDO_POR_COURIER":
        this.stepsToFollow = {
          products: [
            {
              productTitle: "Link de pago Webpay.cl",
              steps: [
                {
                  title: "Correo de confirmación contratación.",
                  subtitle: "En los próximos minutos recibirás un correo electrónico confirmando la contratación de tu Pack, posterior a esto ya estará activo tu comercio en Webpay.cl."
                },
                {
                  title: "Edita tu perfil.",
                  subtitle: "Comparte vía redes sociales, correo o Whatsapp tu link de venta, para que tus clientes puedan pagar online con tarjeta de débito o crédito."
                },
                {
                  title: "Comparte tu link de pago.",
                  subtitle: "Comparte vía redes sociales, correo o Whatsapp tu link de pago, para que tus clientes puedan pagar online con tarjeta de débito o crédito."
                }
              ]
            },
            {
              productTitle: "Pos Movil",
              steps: [
                {
                  title: "Espera nuestro correo de confirmación.",
                  subtitle: "En los próximos minutos recibirás un correo electrónico confirmando el arriendo de tu nuevo equipo. En caso de no recibir nuestro email, revisa tu carpeta SPAM."
                },
                {
                  title: "Coordinaremos el despacho.",
                  subtitle: "Dentro de las 48 horas anteriores a la instalación del equipo te contactaremos para confirmar la fecha y datos de entrega."
                },
                {
                  title: "¡Activa tu equipo y comienza a vender!",
                  subtitle: "Recibirás tu equipo con las instrucciones para que lo actives de manera simple y rápida. ¡Una vez listo podrás vender al instante!"
                }
              ]
            }
          ]
        }
        break;
      case "PACK_POS_MOVIL_LP_PLAZO_INDEFINIDO_POR_TECNICO":
        this.stepsToFollow = {
          products: [
            {
              productTitle: "Link de pago Webpay.cl",
              steps: [
                {
                  title: "Correo de confirmación contratación.",
                  subtitle: "En los próximos minutos recibirás un correo electrónico confirmando la contratación de tu Pack, posterior a esto ya estará activo tu comercio en Webpay.cl."
                },
                {
                  title: "Edita tu perfil.",
                  subtitle: "Comparte vía redes sociales, correo o Whatsapp tu link de venta, para que tus clientes puedan pagar online con tarjeta de débito o crédito."
                },
                {
                  title: "Comparte tu link de pago.",
                  subtitle: "Comparte vía redes sociales, correo o Whatsapp tu link de pago, para que tus clientes puedan pagar online con tarjeta de débito o crédito."
                }
              ]
            },
            {
              productTitle: "Pos Movil",
              steps: [
                {
                  title: "Espera nuestro correo de confirmación.",
                  subtitle: "En los próximos minutos recibirás un correo electrónico confirmando el arriendo de tu nuevo equipo. En caso de no recibir nuestro email, revisa tu carpeta SPAM."
                },
                {
                  title: "Coordinaremos la instalación.",
                  subtitle: "Dentro de las 48 horas anteriores a la instalación del equipo te contactaremos para confirmar la fecha y datos de entrega."
                },
                {
                  title: "Te contactaremos para la instalación.",
                  subtitle: "Un técnico realizará la instalación en tu local y te explicará el funcionamiento básico de tu nuevo equipo. ¡Una vez activado podrás vender al instante!."
                }
              ]
            }
          ]
        }
        break;
      case "INTEGRADOR_TRANSBANK":
        this.stepsToFollow = {
          products: [
            {
              steps: [
                {
                  title: "Espera nuestro correo de confirmación.",
                  subtitle: "Te notificaremos una vez aprobada la solicitud para que continues con la integración de tu servicio Webpay. En caso de no recibir nuestro mail, revisa tu carpeta SPAM."
                },
                {
                  title: "Te contactaremos en los próximos días.",
                  subtitle: "Uno de nuestros expertos solicitará información de tu sitio web y lo evaluará de manera remota para la integración."
                },
                {
                  title: "Proceso de integración.",
                  subtitle: "El proceso de evaluación e integración tomará un máximo de 15 días hábiles, con un costo que varía según la complejidad de integración en tu sitio web, el valor puede variar entre 3.5 a 50 UF."
                },
                {
                  title: "¿Como pago el proceso de integración?",
                  subtitle: "Posterior a la evaluación te enviaremos un correo electrónico con toda la información para que realices el pago único con tarjeta de débito o crédito."
                },
                {
                  title: "¡Haz crecer tu negocio!",
                  subtitle: "Una vez finalidad la integración de Webpay con tu sitio web, estás listo para vender en línea de inmediato."
                }
              ]
            }
          ]
        }
        break;
      case "INTEGRADOR_CLIENTE":
        this.stepsToFollow = {
          products: [
            {
              steps: [
                {
                  title: "Espera nuestro correo de confirmación.",
                  subtitle: "Te notificaremos una vez aprobada la solicitud para que continues con la integración de tu servicio Webpay. En caso de no recibir nuestro mail, revisa tu carpeta SPAM."
                },
                {
                  title: "Inicia el proceso de integración. ",
                  subtitle: "Posterior a que recibas el correo electrónico de confirmación debes iniciar el proceso de integración de tu sitio web con Webpay."
                },
                {
                  title: "Documentación y ayuda.",
                  subtitle: "Ingresa a <a href='https://www.transbankdevelopers.cl' target='_blank' rel='noopener noreferrer'>www.transbankdevelopers.cl</a> para acceder a la documentación de apoyo o contratar un profesional que realice la integración por ti."
                },
                {
                  title: "Se debe validar la integración.",
                  subtitle: "Antes de finalizar el proceso de integración debemos certificar que el desarrollo realizado este funcionando correctamente."
                },
                {
                  title: "¡Haz crecer tu negocio!",
                  subtitle: "Una vez finalidad la integración de Webpay con tu sitio web, estás listo para vender en línea de inmediato."
                }
              ]
            }
          ]
        }
        break;
      case "CREACION_SITIO_ALIANZA_WIX":
        this.stepsToFollow = {
          products: [
            {
              steps: [
                {
                  title: "Asesoría en línea.",
                  subtitle: "Agenda desde nuestra plataforma el día que deseas te contactemos o ingresa desde el link que recibirás en tu correo electrónico en los próximos minutos."
                },
                {
                  title: "Te apoyamos en la creación.",
                  subtitle: "A través de nuestra video llamada recibirás asistencia paso a paso para activar tu sitio web con Wix, cargar tus productos y preparar tu tienda para vender en línea."
                },
                {
                  title: "¡Haz crecer tu negocio!",
                  subtitle: "Finalizando el proceso de asistencia te enviaremos los accesos para administrar tu sitio web. ¡Ya estás listo para vender en línea!"
                }
              ]
            }
          ],
          isWix: true
        }
        break;
      case "COBRO_QR":
        this.stepsToFollow = {
          products: [
            {
              steps: [
                {
                  title: "Espera nuestro correo de confirmación.",
                  subtitle: "En los próximos minutos recibirás un correo electrónico confirmando el arriendo de tu nuevo equipo. En caso de no recibir nuestro email, revisa tu carpeta SPAM."
                },
                {
                  title: "Descarga la app Cobro QR.",
                  subtitle: "Una vez aprobada tu solicitud, ingresa a Apple Store o Google Play para descargar la aplicación en tu teléfono celular."
                },
                {
                  title: "Registrate en el portal privado.",
                  subtitle: "Antes de iniciar a operar con la app Cobro QR, debes ingresar a Acceso Clientes en Transbank, aquí te debes crear tu cuenta con tu RUT y el Código de comercio, enviado vía correo electrónico."
                },
                {
                  title: "Configura la aplicación.",
                  subtitle: " Al iniciar la aplicación debes ingresar tu Rut y la clave con la que accedes a Portal Acceso Clientes."
                },
                {
                  title: "Vende a clientes con billeteras digitales.",
                  subtitle: "En el momento del pago crea el código QR con el monto a cobrar desde tu App Cobro QR en tu teléfono móvil, tu cliente deberá escanear este código con su billetera digital y aceptar el pago. Por el momento disponible para billetera Onepay."
                }
              ]
            }
          ]
        }
        break;
      case "CREACION_SITIO_PST":
        this.stepsToFollow = {
          products: [
            {
              productTitle: "Crea tu sitio web con Proveedor",
              steps: [
                {
                  title: "Contacta a Proveedor.",
                  subtitle: "Cuando recibas el email de confirmación, regístrate en el sitio de Proveedor y contáctate con ellos."
                },
                {
                  title: "Crea tu nuevo sitio web.",
                  subtitle: "Sigue las instrucciones y créalo de forma sencilla. El costo de mantención dependerá del plan contratado con Proveedor."
                },
                {
                  title: "¡Llegó el momento de vender online!.",
                  subtitle: "Publica todos los productos o servicios que quieras ofrecer en Internet y comienza a vender en línea."
                }
              ]
            }
          ]
        }
        break;
      default:
        this.stepsToFollow = {
          products: [
            {
              steps: [
                {
                  title: "Espera nuestro correo de confirmación.",
                  subtitle: "En los próximos minutos recibirás un correo electrónico confirmando el arriendo de tu nuevo equipo. En caso de no recibir nuestro email, revisa tu carpeta SPAM."
                }
              ]
            }
          ]
        }
        break;

    }
  }

  agendaWix() {
    location.href = this.linkWix;
  }

}
